export default __webpack_public_path__ + "static/media/rockclimbing.e6d069f0.svg";